import { useMutation } from 'react-query';
import {
  performanceReportingApiUrl,
  fetcher,
  handleError,
  createParamString,
  ServerErrorResponse,
} from 'data_sources/constants';
import type { ReviewWorkflowDetail, UpdateReviewWorkflowRequest } from '../_types';

export const updateReviewWorkflow = async (
  id: number,
  data: UpdateReviewWorkflowRequest,
  organizationId?: string | null,
  onError?: (errors: ServerErrorResponse) => void
): Promise<ReviewWorkflowDetail> => {
  const baseUrl = `${performanceReportingApiUrl()}/performance/review-workflow/v1/review-workflows/${id}`;
  const queryParams = createParamString({ organizationId });
  const url = queryParams ? `${baseUrl}?${queryParams}` : baseUrl;
  try {
    const response = await fetcher({ url, method: 'PUT', body: data });
    if (response?.errorDetails) {
      if (onError) onError(response);
      throw new Error(JSON.stringify(response));
    }
    return response;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    } else if (onError && error instanceof Error) {
      handleError(error, { onError });
    }
    throw error;
  }
};

export default function useUpdateReviewWorkflow(onError?: (errors: ServerErrorResponse) => void) {
  return useMutation(
    ({ id, data, organizationId }: { id: number; data: UpdateReviewWorkflowRequest; organizationId?: string | null }) =>
      updateReviewWorkflow(id, data, organizationId, onError)
  );
}
